import { MemoryRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import './main.scss';
import InputPanel from './components/InputPanel';
import useSapphirePortalComm, { ISapphirePortalComm } from './comm/SapphirePortalComm';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faDisplay, faArrowRight, faWrench, faCircleNotch,
  faUsersCog, faCube, faSlidersH, faCloud, faDatabase, faEllipsisV, faServer, faHdd, faAngleDown, faAngleRight,
  faUndoAlt, faUserCircle, faSort, faLink, faEdit, faTrash, faCog, faMapMarkerAlt, faUsers, faChalkboardUser, faDoorOpen,
} from '@fortawesome/free-solid-svg-icons';
import SharingPanel from './components/SharingPanel';
import { useEffect, useState } from 'react';
import useWebRTCCaptureMrg from './webrtc/WebRTCCaptureMrg';
import UserfulPageLayout from './layout/UserfulPageLayout';

library.add(faDisplay, faArrowRight, faWrench, faUsersCog, faCube, faSlidersH, faCloud, faDatabase, faEllipsisV, faServer, faHdd, faDoorOpen,
  faAngleDown, faAngleRight, faUndoAlt, faUserCircle, faSort, faLink, faEdit, faTrash, faCircleNotch, faMapMarkerAlt, faCog, faUsers, faChalkboardUser);



interface IProps {
}

export default function App(props:IProps) {
  const [meetingRoomID, setMeetingRoomID] = useState("");
  const [guestName, setGuestName] = useState("");

  const sapphirePortalComm:ISapphirePortalComm = useSapphirePortalComm({
    onOpen:() => {
      sapphirePortalComm.registerClient();
    }
  }
  );

  const {startCasting, endCasting, isCasting} = useWebRTCCaptureMrg(meetingRoomID, guestName, sapphirePortalComm);
  
  useEffect(() => {
    console.log("isCasting=" + isCasting + ";meetingRoomID=" + meetingRoomID);
    sapphirePortalComm.updateCastingMeetingRoom(isCasting, meetingRoomID, isCasting ? guestName : "");
  },[isCasting]);

  return (
    <div className="App">
      <UserfulPageLayout className="main-container" showHelp showWindowMax version="12.2">
        <Router>
          <Routes>
            <Route path="/" element={<InputPanel 
                meetingRoomID={meetingRoomID} 
                setMeetingRoomID={setMeetingRoomID} 
                guestName={guestName}
                setGuestName={setGuestName}
                availableMeetingRooms={sapphirePortalComm.availableMeetingRooms}
                isMeetingRoomAvailable={sapphirePortalComm.isMeetingRoomAvailable}
                isMeetingRoomOccupied={sapphirePortalComm.isMeetingRoomOccupied}
                startCasting={startCasting}
                isCasting={isCasting}/>
            } />

            <Route path="/casting" element={
                <SharingPanel meetingRoomID={meetingRoomID} endCasting={endCasting} isCasting={isCasting}/>
              } />
          </Routes>        
        </Router>
      </UserfulPageLayout>
    </div>
  );
  
}
